<template>
  <el-dialog
    :title="'Theo dõi chi tiết tiền nạp đại lý'"
    :visible.sync="dialogWalletDetailVisible"
    width="70%"
    :close-on-click-modal="false"
    @open="onOpen"
    @close="onClose"
  >
    <div class="statistics">
      <InfoList :columns="1">
        <InfoListLabel>{{ 'ĐẠI LÝ' }}</InfoListLabel>
        <InfoListValue
          ><span class="font-bold text-lg relative bottom-0"
            >{{ agentName }}
          </span>
        </InfoListValue>

        <InfoListLabel>{{ 'TỔNG SỐ TIỀN NẠP' }}</InfoListLabel>
        <InfoListValue
          ><span class="font-bold text-lg relative bottom-0"
            >{{ formatVND(info.depositMoney) }} VND
          </span>
        </InfoListValue>
        <InfoListLabel>{{ 'SỐ TIỀN NẠP ĐÃ SỬ DỤNG' }}</InfoListLabel>
        <InfoListValue
          ><span class="font-bold text-lg relative bottom-0"
            >{{ formatVND(info.usageMoney) }} VND
          </span>
        </InfoListValue>
        <InfoListLabel>{{ 'SỐ DƯ' }}</InfoListLabel>
        <InfoListValue
          ><span class="font-bold text-lg relative bottom-0"
            >{{ formatVND(info.balanceMoney) }} VND
          </span>
        </InfoListValue>
      </InfoList>
    </div>

    <!-- Grid -->
    <div class="grid-scroll" style="height: calc(45px + 10 * 34px)">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :rows="rows"
        class="agGrid"
        dom-layout="scroll"
        :auto-select-first-row="false"
        :auto-size-cell="true"
        :row-multi-select-with-click="true"
      />
    </div>

    <!-- Pagination -->
    <div class="grid-bottom">
      <GridPaging
        target="agGrid"
        :total-size="pageParams.totalPage"
        :page-num="pageParams.pageNum"
        @pageChanged="onPageChanged"
        @onPageSizeChange="onPageSizeChange"
      />
    </div>

    <!-- Footer btns -->
    <span slot="footer" class="dialog-footer">
      <div class="button-containers">
        <button
          class="btn primary small outline"
          @click="dialogWalletDetailVisible = false"
        >
          Đóng
        </button>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import InfoList from '@/components/info-list/InfoList.vue'
import InfoListLabel from '@/components/info-list/InfoListLabel.vue'
import InfoListValue from '@/components/info-list/InfoListValue.vue'
import paginationMixin from '@/mixins/paginationMixin'
import { formatVND } from '@/utils/commonUtils'
import { getAgentWalletDetail } from '@/api/accounting/agent-wallet'
import { notifyError } from '@/utils/toast'

export default {
  components: { InfoList, InfoListLabel, InfoListValue },
  mixins: [paginationMixin],
  props: {
    agentId: {
      type: Number
    },
    agentName: {
      type: String
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      columns: [
        { headerName: 'STT', field: 'no', width: 50 },
        { headerName: 'Ngày', field: 'date', width: 100 },
        {
          headerName: 'Số tiền nạp',
          field: 'amount',
          valueGetter: params => formatVND(params.data.amount),
          cellClass: 'grid-cell-right',
          width: 100
        },
        { headerName: 'Người thao tác', field: 'user_name', width: 100 },
        { headerName: 'Lý do', field: 'note' }
      ],
      rows: [],

      info: {
        usageMoney: 0,
        depositMoney: 0,
        balanceMoney: 0
      }
    }
  },

  computed: {
    dialogWalletDetailVisible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },

  methods: {
    formatVND,
    onOpen() {
      // init data
      this.rows = []
      this.pageParams.pageNum = 1
      this.pageParams.pageSize = 10
      this.fnGetAgentWalletDetail()
    },
    onClose() {
      // reset before close dialog
      this.rows = []
      this.pageParams.pageNum = 1
      this.pageParams.pageSize = 10
    },

    // pagination
    async onPageChanged(pageNum) {
      this.pageParams.pageNum = pageNum
      await this.fnGetAgentWalletDetail()
    },
    async onPageSizeChange(pageSize) {
      this.pageParams.pageSize = pageSize
      this.pageParams.pageNum = 1
      await this.fnGetAgentWalletDetail()
    },

    // handle api call
    async fnGetAgentWalletDetail() {
      const query = {
        agentId: this.agentId,
        pageSize: this.pageParams.pageSize,
        currentPage: this.pageParams.pageNum
      }
      let res
      try {
        res = await getAgentWalletDetail(query)
        if (res.data.length === 1 && !res.data[0]?.no) {
          this.rows = []
        } else {
          this.rows = res.data
        }
        this.pageParams.totalPage = Math.ceil(
          res.total / this.pageParams.pageSize
        )

        if (this.rows.length > 0) {
          this.info.usageMoney = this.rows[0].total_payment || 0
          this.info.depositMoney = this.rows[0].total_deposit || 0
          this.info.balanceMoney = this.rows[0].balance || 0
        }
      } catch (error) {
        const message = error.response?.data?.message || 'default'
        notifyError(message)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.statistics {
  margin-bottom: 14px;
}
</style>
